import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { Provider } from 'react-redux';

import App from './App';
import ScannerProvider from './utilities/ScannerContext';
import * as serviceWorker from './serviceWorker';
import './i18n';

import store from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ScannerProvider>
        <App />
      </ScannerProvider>
    </BrowserRouter>
  </Provider>,
);
serviceWorker.unregister();
